<template>
  <v-container
          class="fill-height"
          fluid
  >
    <h1>Leistungen diesen Monat</h1>
<!--    <v-btn fab text small color="grey darken-2" @click="prev">
      <v-icon small>mdi-chevron-left</v-icon>
    </v-btn>
    <v-btn fab text small color="grey darken-2" @click="next">
      <v-icon small>mdi-chevron-right</v-icon>
    </v-btn>-->
    <v-calendar :events="services" type="month" event-overlap-mode="stack" locale="de-CH" @click:event="showEvent" ref="calendar"></v-calendar>
  </v-container>
</template>

<script>
// @ is an alias to /src

import {serviceService} from "../services/serviceService";
import router from "../router";

export default {
  name: 'Home',
  data() {
    return {
      services: [],
    }
  },
  methods: {
    getShortText(text) {
      if (text.length > 15) {
        var trimmedString = text.substr(0, 15);

        return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + "..."
      }
      return text
    },
    formatDate (a, withTime) {
      return withTime
              ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
              : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`
    },
    showEvent({ nativeEvent, event }) {
      router.push("/services/"+event.id);
      return nativeEvent;
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
  },
  created() {
    let self = this;

    serviceService.getServices().then((services) => {
      for (var i = 0; i < services.length; i++){
        self.services.push({
          id: services[i].id,
          name: self.getShortText(services[i].description),
          start: self.formatDate(new Date(services[i].startDate), false),
          end: self.formatDate(new Date(services[i].endDate), false),
        })
      }
    })
  }
}
</script>
